import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";

const ErrorPage = () => {
    const navigate = useNavigate();
    const [clock, setClock] = useState("");

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            setClock(now.toLocaleTimeString("en-GB")); // Update clock in 24-hour format
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const handleReturnToMain = () => {
        navigate("/");
    };

    return (
        <div className="container">
            <h1 className="title">שגיאה</h1>
            <p className="message">אירעה שגיאה. אנא נסו שוב מאוחר יותר.</p>
            {/*<button className="confirm-button" onClick={handleReturnToMain}>*/}
            {/*    חזור לדף הראשי*/}
            {/*</button>*/}
            {/*<footer className="footer">*/}
            {/*    <div className="footer-content">*/}
            {/*        <p>*/}
            {/*            שעה נוכחית:{" "}*/}
            {/*            <span className="highlight">{clock}</span>*/}
            {/*        </p>*/}
            {/*        <p>&copy; {new Date().getFullYear()} BluePT</p>*/}
            {/*    </div>*/}
            {/*</footer>*/}
        </div>
    );
};

export default ErrorPage;
